import { useTheme } from "../hooks/useTheme";
import { themes, THEME_SWITCHER_ENABLED } from "../data/themes";

export default function ThemeToggle() {
  const { theme, nextTheme } = useTheme();
  if (!THEME_SWITCHER_ENABLED) return null;
  const index = themes.findIndex((item) => item.id === theme.id);
  return (
    <>
      <button
        className="theme-toggle"
        onClick={nextTheme}
        aria-label={`Change color theme. Current: ${theme.name}. Next: ${themes[(index + 1) % themes.length].name}`}
        title={`${theme.description} · Click to try the next palette`}
      >
        <span className="theme-swatch" aria-hidden="true">
          <i />
          <i />
          <i />
          <i />
        </span>
        <span className="theme-name" key={theme.id}>
          {theme.name}
        </span>
        <span className="theme-count mono" aria-hidden="true">
          0{index + 1}
          <span>/04</span>
        </span>
      </button>
      <span className="sr-only" role="status">
        {theme.name} color theme
      </span>
    </>
  );
}
